﻿import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './scss/site.scss';
import {QueryClient, QueryClientProvider} from 'react-query';
import {ClientConfigProvider} from './hooks/useClientConfig.tsx';
import {ErrorBoundary} from './components/shared/ErrorBoundary.tsx';
import {stripCacheBustParamFromUrl} from './lib/chunkReloadGuard.ts';

(function () {
    if (window.location.host === 'mixiply.azurewebsites.net') {
        window.location.href = 'https://mixiply.com';
        return;
    }

    if (window.location.protocol !== 'https:') {
        window.location.href = 'https://' + window.location.host;
    }

    if (window.location.hostname === 'www.mixiply.com') {
        window.location.href = window.location.href.replace(
            'www.mixiply.com',
            'mixiply.com'
        );
    }
})();

// The stale-chunk recovery screen reloads with a throwaway `_r` query parameter to bypass
// cached copies of the page. Drop it from the address bar before the router reads the URL.
stripCacheBustParamFromUrl();

const queryClient = new QueryClient();

const consoleWarn = console.warn;
const suppressedWarnings = [
    'ArtificialNode__DO_NOT_USE', // For lexical
    'Failed prop type: Invalid prop `nodeRef`'
];

console.warn = (message, ...args) => {
    if (
        typeof message === 'string' &&
        suppressedWarnings.some(entry => message.includes(entry))
    ) {
        return;
    }
    consoleWarn(message, ...args);
};

// ErrorBoundary is the outermost wrapper so the recovery screen never depends on the
// provider/router tree that may itself be the broken thing.
ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <ClientConfigProvider>
                    <App />
                </ClientConfigProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    </React.StrictMode>
);
